interface IconProps {
	active?: boolean;
	color?: string;
}

export const OutboundIcon = ({ active, color }: IconProps) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			d="M4.96558 20.3938L15.8594 9.5L16.4806 18.8392"
			stroke={active ? color : '#0F0F0F'}
			strokeWidth="1.5"
		/>
		<path
			d="M6.14053 15.1216L17.0343 4.22775L9.86913 3.60656"
			stroke={active ? color : '#0F0F0F'}
			strokeWidth="1.5"
		/>
	</svg>
);
